import { useState, useEffect, useRef } from "react";
import {
	Elements,
	CardElement,
	useStripe,
	useElements,
} from "@stripe/react-stripe-js";

import { API_URL, translate } from "../../utils";
import useFetch from "../../utils/useFetch";

import Alert from "../../components/Alert";
import Checkboxes from "../../components/Checkboxes";
import InputStripe from "../../components/InputStripe";
import Terms from "../../components/Terms";
import Msg from "../../components/Msg";
import Submit from "../../components/Submit";

import Hdg from "./Hdg";
//import FeeTable from "./FeeTable";
import FeeTableAlt from "./FeeTableAlt";
import FeeTableAlt2 from "./FeeTableAlt2";
import JuniorFields from "./JuniorFields";
import ParentFields from "./ParentFields";
import OrderTable from "./OrderTable";

const Home = ({ status, lang }) => {
	const [url, setUrl] = useState(null);
	const [names, setNames] = useState({
		events: [],
	});
	const [msg, setMsg] = useState({});
	const [errors, setErrors] = useState([]);
	const [events, setEvents] = useState([]);
	const [totals, setTotals] = useState({
		subtotal: 0,
		discount: 0,
		total: 0,
	});

	const formElement = useRef(null);
	const stripe = useStripe();
	const elements = useElements();
	const { loading, data } = useFetch(url);

	useEffect(() => {
		const newUrl = new URL(`${API_URL}/jgsHomeInit`);
		const params = {
			lang,
		};
		newUrl.search = new URLSearchParams(params);
		setUrl(newUrl);
	}, []);

	useEffect(() => {
		if (data && data.resp === 1) {
			setEvents(data.events);
			setNames((names) => ({
				...names,
				phoneCode: data.phoneCode,
				country: data.country,
			}));
		}
	}, [data]);

	useEffect(() => {
		if (names.events.length === 0) {
			setTotals({
				subtotal: 0,
				discount: 0,
				total: 0,
			});
		} else {
			/*let subtotal = names.events.length * 80000;
			let discount = names.events.length > 2 ? 40000 : 0;
			let total = subtotal - discount;*/

			let subtotal = 0;
			let discount = 0;
			let total = 0;

			if (names.events.includes("september26")) {
				subtotal = subtotal + 80000;
			}

			if (names.events.includes("october3")) {
				subtotal = subtotal + 120000;
			}

			total = subtotal;

			setTotals({
				subtotal,
				discount,
				total,
			});
		}
	}, [names.events]);

	const handleUpdate = (name, value) => {
		const filtered = events.filter((item) => {
			return item.id === name;
		});

		if (filtered.length > 0) {
			if (value) {
				setNames((prev) => ({
					...prev,
					events: [...prev.events, name],
				}));
			} else {
				let newArray = names.events;
				newArray = names.events.filter((item) => item !== name);
				setNames((names) => ({ ...names, events: newArray }));
			}
		} else {
			setNames((names) => ({ ...names, [name]: value }));
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		setErrors([]);
		setMsg({
			type: "working",
			text: "",
		});

		const url = new URL(`${API_URL}/jgsHome`);
		let formData = new FormData();
		Object.entries(names).forEach(([key, value]) => {
			if (key === "events") {
				formData.append(key, JSON.stringify(value));
			} else if (key === "nationality") {
				formData.append(key, value ? "1" : "0");
			} else {
				formData.append(key, value);
			}
		});
		formData.append("totals", JSON.stringify(totals));
		formData.append("lang", lang);

		try {
			const response = await fetch(url, {
				method: "POST",
				body: formData,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				handlePayment(json.clientSecret, json.details);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text:
					lang === "en"
						? "An error has occurred."
						: "Se ha producido un error.",
			});
		}
	};

	const handlePayment = async (clientSecret, details) => {
		const result = await stripe.confirmCardPayment(clientSecret, {
			payment_method: {
				card: elements.getElement(CardElement),
				billing_details: {
					name: `${names.fname} ${names.lname}`,
					email: `${names.email}`,
				},
			},
		});

		if (result.error) {
			setMsg({
				type: "error",
				text: result.error.message,
			});
		} else {
			if (result.paymentIntent.status === "succeeded") {
				handleSuccess(
					{
						id: result.paymentIntent.id,
						status: result.paymentIntent.status,
						paymentMethod: result.paymentIntent.payment_method,
						amount: result.paymentIntent.amount,
						currency: result.paymentIntent.currency,
					},
					details,
				);
			}
		}
	};

	const handleSuccess = async (stripeResponse, details) => {
		const url = new URL(`${API_URL}/jgsSubmit`);
		let data = new FormData();
		Object.entries(names).forEach(([key, value]) => data.append(key, value));
		data.append("stripeResponse", JSON.stringify(stripeResponse));
		data.append("details", JSON.stringify(details));

		try {
			const response = await fetch(url, {
				method: "POST",
				body: data,
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				status(json.id, 1);
			} else {
				setErrors(json.fields);
				setMsg({
					type: "error",
					text: json.text,
				});
			}
		} catch (error) {
			setMsg({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{loading ? (
				<Alert
					data={{
						type: "working",
						text: "",
					}}
				/>
			) : (
				<>
					<Hdg translate={translate} lang={lang} />

					<form
						ref={formElement}
						method="post"
						action="/"
						onSubmit={(e) => handleSubmit(e)}
					>
						{/*<<FeeTable translate={translate} lang={lang} />*/}
						{/*<FeeTableAlt translate={translate} lang={lang} />*/}
						<FeeTableAlt2 translate={translate} lang={lang} />

						<h3 style={{ marginBottom: "0" }}>
							{translate(lang, "Select Events", "Selecciona el o los Torneos")}
						</h3>

						<div className="form-group radios" style={{ marginBottom: "15px" }}>
							<Checkboxes
								type="v2"
								label=""
								reqd={false}
								data={events.map((event) => {
									return {
										name: event.id,
										val: "",
										label: `${translate(lang, event.name, event.name)}`,
									};
								})}
								values={names.events}
								click={handleUpdate}
							/>
						</div>

						<h3>
							{translate(
								lang,
								"Información del Participante",
								"Información del Participante",
							)}
						</h3>

						<JuniorFields
							translate={translate}
							lang={lang}
							data={{
								fname: names.fname,
								lname: names.lname,
								dobDay: names.dobDay,
								dobMonth: names.dobMonth,
								dobYear: names.dobYear,
								hometown: names.hometown,
								st1: names.st1,
							}}
							handleUpdate={handleUpdate}
							errors={errors}
						/>

						<h3
							style={{
								marginTop: "12.5px",
							}}
						>
							{translate(lang, "Padre o Tutor", "Padre o Tutor")}
						</h3>

						<ParentFields
							translate={translate}
							lang={lang}
							data={{
								parentFname: names.parentFname,
								parentLname: names.parentLname,
								email: names.email,
								phoneCode: names.phoneCode,
								phone: names.phone,
								country: names.country,
								residence: names.residence,
								st2: names.st2,
							}}
							handleUpdate={handleUpdate}
							errors={errors}
						/>

						<h3
							style={{
								marginTop: "12.5px",
								marginBottom: "5px",
							}}
						>
							{translate(
								lang,
								"Exención de Responsabilidad y Uso de Imagen",
								"Exención de Responsabilidad y Uso de Imagen",
							)}
						</h3>

						<div className="form-group radios inline">
							<Checkboxes
								label=""
								reqd={false}
								data={[
									{
										name: "nationality",
										val: "",
										label: `${translate(
											lang,
											"Reconozco que la participación en actividades de golf implica riesgos de lesiones y accidentes. Al aceptar esta casilla, autorizo la participación de mi hijo(a) y libero de responsabilidad a los organizadores, patrocinadores y sedes del evento por cualquier lesión, accidente o daño relacionado con la participación de mi hijo(a). Asimismo, autorizo el uso de la imagen, fotografía y/o video de mi hijo(a) captados durante el evento para fines promocionales y de difusión.",
											"Reconozco que la participación en actividades de golf implica riesgos de lesiones y accidentes. Al aceptar esta casilla, autorizo la participación de mi hijo(a) y libero de responsabilidad a los organizadores, patrocinadores y sedes del evento por cualquier lesión, accidente o daño relacionado con la participación de mi hijo(a). Asimismo, autorizo el uso de la imagen, fotografía y/o video de mi hijo(a) captados durante el evento para fines promocionales y de difusión.",
										)}`,
									},
								]}
								values={[names.nationality || false]}
								click={handleUpdate}
							/>
						</div>

						<h3
							style={{
								marginTop: "12.5px",
							}}
						>
							{translate(lang, "Payment", "Pago")}
						</h3>

						<OrderTable
							translate={translate}
							lang={lang}
							eventDataArray={events}
							events={names.events}
							totals={totals}
						/>

						<div className="form-group one">
							<InputStripe
								name="card"
								label={translate(
									lang,
									"Tarjeta de Débito o Crédito",
									"Tarjeta de Débito o Crédito",
								)}
								reqd={true}
							/>
						</div>

						<Terms
							hdg={translate(
								lang,
								"Verifica los detalles y haz click en procesar pago para confirmar tu inscripción.",
								"Verifica los detalles y haz click en procesar pago para confirmar tu inscripción.",
							)}
							text={translate(
								lang,
								`Todos los cargos a tarjeta de débito o crédito se verán reflejados como “WWT CHAMPIONSHIP” en tu estado de cuenta. Al hacer click en el botón de procesar pago, confirmarás tu participación y se hará un cargo a tu tarjeta. Todas las ventas son finales. En caso de hacer WD antes de la fecha límite que es el domingo antes de cada torneo, se te cobrará un cargo de cancelación de $400 MXN. En caso de hacer WD después de la fecha límite, no hay reembolso. Al ingresar la información del pago, aceptaste las condiciones de compra.`,
								`Todos los cargos a tarjeta de débito o crédito se verán reflejados como “WWT CHAMPIONSHIP” en tu estado de cuenta. Al hacer click en el botón de procesar pago, confirmarás tu participación y se hará un cargo a tu tarjeta. Todas las ventas son finales. En caso de hacer WD antes de la fecha límite que es el domingo antes de cada torneo, se te cobrará un cargo de cancelación de $400 MXN. En caso de hacer WD después de la fecha límite, no hay reembolso. Al ingresar la información del pago, aceptaste las condiciones de compra.`,
							)}
						/>
						<div className="msg-submit">
							{msg.type && <Msg data={msg} />}
							<div
								className={
									msg.type === "working" || msg.type === "success"
										? "hidden"
										: "submit-container"
								}
							>
								<Submit
									path=""
									left=""
									submit={translate(lang, "Procesar Pago", "Procesar Pago")}
								/>
							</div>
						</div>
					</form>
				</>
			)}
		</>
	);
};

const Payment = ({ status, stripePromise, lang }) => {
	return (
		<Elements stripe={stripePromise}>
			<Home status={status} lang={lang} />
		</Elements>
	);
};

export default Payment;
